import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const timerecordUserDataClassName = DataClassName.TIMERECORD_USER
const timerecordUserEndpoint = PisaDataClassEndpoint.TIMERECORD_USER

export function pisaTimerecordUserDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(timerecordUserDataClassName, {
    title: timerecordUserDataClassName,
    restApi: createPisaRestApiConfig(timerecordUserEndpoint),
    attributes,
  })
}
